const getCorporateLocations = state => state?.settings?.corporateLocationsList
const getSingleLocationData = state => state?.settings?.singleLocationData

const selectors = {
  getCorporateLocations,
  getSingleLocationData,
}
export default selectors
